import { YupSchema } from 'services/yup/types'
import { yupArray, yupIgnore } from 'services/yup'
import { optionedProductVS } from './optionedProduct'
import { APIPriceRange } from 'services/api/entities/catalog/types'
import { Food } from 'services/api/entities/catalog/food/types/internal/food-models'

export const foodVS: YupSchema<Food, APIPriceRange[] | undefined> =
  optionedProductVS.shape({
    logistics: yupArray().min(1),
    upsellingItems: yupArray(),
    upsellingItemsFull: yupArray(),
    logisticsFull: yupArray(),
    tagFacets: yupIgnore(),
    filterTypeFacet: yupIgnore(),
  })
